import { createSlice } from "@reduxjs/toolkit";
import uploadVideoMicroscopy from "@custom/rtk-apis/microscopy/uploadVideo";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const uploadVideoMicroscopySlice = createSlice({
  name: "uploadVideoMicroscopy",
  initialState,
  reducers: {
    resetUploadVideoState: () => initialState,
    resetStatus (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(uploadVideoMicroscopy.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(uploadVideoMicroscopy.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(uploadVideoMicroscopy.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default uploadVideoMicroscopySlice.reducer;
export const { resetStatus,resetUploadVideoState } = uploadVideoMicroscopySlice.actions;
